var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvoyIssue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.7 14.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#eb6c25;stroke-miterlimit:10;stroke-width:0.75px;}.cls-2{fill:#eb6c25;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.38,
    y: 0.38,
    width: 14.95,
    height: 13.48,
    rx: 1.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.16,8.81a.43.43,0,0,0,.62,0h0a.4.4,0,0,0,.06-.58l0-.05a5.6,5.6,0,0,0-7.9-.14.43.43,0,0,0,0,.62h0a.41.41,0,0,0,.58.06s0,0,0-.05a4.66,4.66,0,0,1,6.58.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.44,10.29a.44.44,0,0,0,.62,0h0a2.4,2.4,0,0,1,3.38,0l0,0a.43.43,0,0,0,.62,0h0a.41.41,0,0,0,.07-.58l-.06,0a3.24,3.24,0,0,0-4.58-.08C5.29,9.89,5.29,10.13,5.44,10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2,6.2a.43.43,0,0,0,0,.62H2a.4.4,0,0,0,.58.06l.05,0A7.34,7.34,0,0,1,13,7a.44.44,0,0,0,.62,0h0a.41.41,0,0,0,.07-.58l-.06,0A8.25,8.25,0,0,0,2,6.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvoyIssue2);
export default __webpack_public_path__ + "static/media/envoy_issue2.d95ba9fc290444394484907635ba486a.svg";
export { ForwardRef as ReactComponent };